<template lang="pug">
.search-branch
  textbox-search.search-branch__action(v-model='academyNameValue', :placeholder='academyNamePlaceholder')
  textbox-search.search-branch__action(v-model='branchNameValue', :placeholder='branchNamePlaceholder')
  textbox-search.search-branch__action(v-model='branchCodeValue', :placeholder='branchCodePlaceholder')
  button-search.search-branch__action(@click='searchEvent')
    slot(name='searchButtonText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TextboxSearch from '@/components/molecules/manager/TextboxSearch.vue'
import ButtonSearch from '@/components/molecules/manager/ButtonSearch.vue'

/**
 * 教室絞り込み
 */
@Component({
  components: {
    TextboxSearch,
    ButtonSearch,
  },
})
export default class SearchBranch extends Vue {
  // 塾名（ユーザ権限がシステム管理者の場合のみ設定）
  @Prop()
  academyName?: string

  // 教室名
  @Prop()
  branchName!: string

  // 教室コード
  @Prop()
  branchCode!: string

  // 塾名プレースホルダー（ユーザ権限がシステム管理者の場合のみ設定）
  @Prop()
  academyNamePlaceholder?: string

  // 教室名プレースホルダー
  @Prop()
  branchNamePlaceholder!: string

  // 教室コードプレースホルダー
  @Prop()
  branchCodePlaceholder!: string

  // 塾名変更時のイベント（ユーザ権限がシステム管理者の場合のみ設定）
  @Prop()
  academyNameChangeEvent?: Function

  // 教室名変更時のイベント
  @Prop()
  branchNameChangeEvent!: Function

  // 教室コード変更時のイベント
  @Prop()
  branchCodeChangeEvent!: Function

  // 検索イベント
  @Prop()
  searchEvent!: Function

  /*
   * 入力値ゲッター・セッター
   */
  // 塾名
  get academyNameValue(): string {
    return this.academyName || ''
  }
  set academyNameValue(value: string) {
    if (this.academyNameChangeEvent) {
      this.academyNameChangeEvent(value)
    }
  }
  // 教室名
  get branchNameValue(): string {
    return this.branchName
  }
  set branchNameValue(value: string) {
    this.branchNameChangeEvent(value)
  }
  // 教室コード
  get branchCodeValue(): string {
    return this.branchCode
  }
  set branchCodeValue(value: string) {
    this.branchCodeChangeEvent(value)
  }
}
</script>

<style lang="stylus" scoped>
.search-branch
  display flex

  &__action
    margin 7px 5px
</style>
